import { OptionType } from '@/modules/common/types';

import { ModelRestriction } from '../types';

type ReturnType = {
  type: OptionType[];
  color: OptionType[];
  gender: OptionType[];
};

export function getAllModelOptions(items: ModelRestriction[]): ReturnType {
  // Helper: unique by "value"
  const uniqueByValue = (arr) => {
    const map = new Map();
    arr.forEach((obj) => {
      if (!map.has(obj.value)) map.set(obj.value, obj);
    });
    return [...map.values()];
  };

  const result: ReturnType = {
    type: [],
    color: [],
    gender: [],
  };

  Object.keys(result).forEach((key) => {
    const values = items.map((i) => i[key]);
    result[key] = uniqueByValue(values);
  });

  return result;
}
